var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CardFileUploadStatus, } from "@affinitysystemsgroup/assurehub-ui";
import { putToSignedUrl } from "ah_utility/api";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
import { formatCollectionMonthYear, formatCollectionPeriod, getCollectionStatusLabel, getCollectionStatusToneBucket, } from "../../../model/collection";
import { formattedDate } from "../../../utils/date";
import { buildCollectMaxFilesMessage, COLLECT_BACK_BUTTON_LABEL, COLLECT_COMPLETED_STATUS, COLLECT_DEFAULT_COLLECTION_OPTION, COLLECT_DEFAULT_CONTENT_TYPE, COLLECT_EXPIRED_LINK_STATUS, COLLECT_EXTENSION_MESSAGE, COLLECT_FILE_SIZE_MESSAGE, COLLECT_GENERIC_ERROR_MESSAGE, COLLECT_NO_FILES_SELECTED_MESSAGE, COLLECT_NO_VALUE_LABEL, COLLECT_PAGE_TITLE, COLLECT_PAGE_TITLE_COMPLETED, COLLECT_POLL_INTERVAL_MS, COLLECT_POLL_MAX_DURATION_MS, COLLECT_PROCESS_BUTTON_LABEL, COLLECT_PROCESSING_STATUS, COLLECT_UPLOAD_BUTTON_LABEL, COLLECT_UPLOAD_FAILED_MESSAGE, COLLECT_UPLOAD_LINK_EXPIRED_MESSAGE, COLLECT_UPLOAD_SUCCESS_MESSAGE, } from "../constants/collect.constants";
import { getCollectRulesConfig, hasAllowedExtension, isWithinSizeLimit, resolveMaxFiles, } from "../constants/collectRules.config";
var DETAIL_REQUEST_KEY = "collectDetail";
var UPLOAD_URLS_REQUEST_KEY = "collectUploadUrls";
var PRE_SUMMARY_REQUEST_KEY = "collectPreSummary";
var FROM_URLS_REQUEST_KEY = "collectFromUrls";
var STATUS_BUCKET_TO_TONE = {
    IN_PROGRESS: "info",
    COMPLETED: "positive",
    FAILED: "negative",
};
var RESULT_KPI_DEFS = [
    { id: "paidNotes", label: "Notas de cobro pagadas", tone: "pos" },
    { id: "totalPaidAmount", label: "Monto total pagado", tone: "pos" },
    {
        id: "canceledPolicies",
        label: "Pólizas a estatus cancelado",
        tone: "neutral",
    },
    { id: "pendingOrSuspended", label: "Pendiente o suspenso", tone: "warn" },
];
var REVIEW_ITEM_DEFS = [
    { id: "rejectedNotes", label: "Notas de cobro rechazadas" },
    { id: "paymentsNotFound", label: "Pagos no localizados" },
    { id: "rejectedNotFound", label: "Rechazados no localizados" },
    { id: "policiesNotFound", label: "Pólizas no localizadas" },
];
export var useCollect = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var paramId = useParams().id;
    var state = useLocation().state;
    var id = (_a = paramId !== null && paramId !== void 0 ? paramId : state === null || state === void 0 ? void 0 : state.id) !== null && _a !== void 0 ? _a : "";
    var collectRules = getCollectRulesConfig();
    var _x = useState([]), newFiles = _x[0], setNewFiles = _x[1];
    var _y = useState({}), uploadStatuses = _y[0], setUploadStatuses = _y[1];
    var _z = useState(false), transferring = _z[0], setTransferring = _z[1];
    var filesRef = useRef([]);
    filesRef.current = newFiles;
    var uploadedFilesRef = useRef([]);
    var pollTimeoutRef = useRef(null);
    var pollStartedAtRef = useRef(null);
    var _0 = useState({
        show: false,
        message: "",
        type: "success",
    }), toast = _0[0], setToast = _0[1];
    var _1 = useState(false), reviewModalOpen = _1[0], setReviewModalOpen = _1[1];
    var _2 = useState(false), confirmModalOpen = _2[0], setConfirmModalOpen = _2[1];
    var detail = useSelector(function (reduxState) { var _a, _b, _c; return (_c = (_b = (_a = reduxState.CustomRequest) === null || _a === void 0 ? void 0 : _a.dataCustomRequest) === null || _b === void 0 ? void 0 : _b[DETAIL_REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var loadingDetail = useSelector(function (reduxState) {
        var _a, _b, _c;
        return (_c = (_b = (_a = reduxState.CustomRequest) === null || _a === void 0 ? void 0 : _a.loadingCustomRequest) === null || _b === void 0 ? void 0 : _b[DETAIL_REQUEST_KEY]) !== null && _c !== void 0 ? _c : false;
    });
    var errorDetail = useSelector(function (reduxState) {
        var _a, _b, _c;
        return (_c = (_b = (_a = reduxState.CustomRequest) === null || _a === void 0 ? void 0 : _a.errorCustomRequest) === null || _b === void 0 ? void 0 : _b[DETAIL_REQUEST_KEY]) !== null && _c !== void 0 ? _c : null;
    });
    var productCount = (_d = (_c = (_b = detail === null || detail === void 0 ? void 0 : detail.parameters) === null || _b === void 0 ? void 0 : _b.projectsId) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0;
    var maxFiles = resolveMaxFiles(collectRules, { productCount: productCount });
    var responseUploadUrls = useSelector(function (reduxState) {
        var _a, _b, _c;
        return (_c = (_b = (_a = reduxState.CustomRequest) === null || _a === void 0 ? void 0 : _a.dataCustomRequest) === null || _b === void 0 ? void 0 : _b[UPLOAD_URLS_REQUEST_KEY]) !== null && _c !== void 0 ? _c : null;
    });
    var loadingUploadUrls = useSelector(function (reduxState) {
        var _a, _b, _c;
        return (_c = (_b = (_a = reduxState.CustomRequest) === null || _a === void 0 ? void 0 : _a.loadingCustomRequest) === null || _b === void 0 ? void 0 : _b[UPLOAD_URLS_REQUEST_KEY]) !== null && _c !== void 0 ? _c : false;
    });
    var errorUploadUrls = useSelector(function (reduxState) {
        var _a, _b, _c;
        return (_c = (_b = (_a = reduxState.CustomRequest) === null || _a === void 0 ? void 0 : _a.errorCustomRequest) === null || _b === void 0 ? void 0 : _b[UPLOAD_URLS_REQUEST_KEY]) !== null && _c !== void 0 ? _c : null;
    });
    var responsePreSummary = useSelector(function (reduxState) {
        var _a, _b, _c;
        return (_c = (_b = (_a = reduxState.CustomRequest) === null || _a === void 0 ? void 0 : _a.dataCustomRequest) === null || _b === void 0 ? void 0 : _b[PRE_SUMMARY_REQUEST_KEY]) !== null && _c !== void 0 ? _c : null;
    });
    var loadingPreSummary = useSelector(function (reduxState) {
        var _a, _b, _c;
        return (_c = (_b = (_a = reduxState.CustomRequest) === null || _a === void 0 ? void 0 : _a.loadingCustomRequest) === null || _b === void 0 ? void 0 : _b[PRE_SUMMARY_REQUEST_KEY]) !== null && _c !== void 0 ? _c : false;
    });
    var errorPreSummary = useSelector(function (reduxState) {
        var _a, _b, _c;
        return (_c = (_b = (_a = reduxState.CustomRequest) === null || _a === void 0 ? void 0 : _a.errorCustomRequest) === null || _b === void 0 ? void 0 : _b[PRE_SUMMARY_REQUEST_KEY]) !== null && _c !== void 0 ? _c : null;
    });
    var responseFromUrls = useSelector(function (reduxState) {
        var _a, _b, _c;
        return (_c = (_b = (_a = reduxState.CustomRequest) === null || _a === void 0 ? void 0 : _a.dataCustomRequest) === null || _b === void 0 ? void 0 : _b[FROM_URLS_REQUEST_KEY]) !== null && _c !== void 0 ? _c : null;
    });
    var loadingFromUrls = useSelector(function (reduxState) {
        var _a, _b, _c;
        return (_c = (_b = (_a = reduxState.CustomRequest) === null || _a === void 0 ? void 0 : _a.loadingCustomRequest) === null || _b === void 0 ? void 0 : _b[FROM_URLS_REQUEST_KEY]) !== null && _c !== void 0 ? _c : false;
    });
    var errorFromUrls = useSelector(function (reduxState) {
        var _a, _b, _c;
        return (_c = (_b = (_a = reduxState.CustomRequest) === null || _a === void 0 ? void 0 : _a.errorCustomRequest) === null || _b === void 0 ? void 0 : _b[FROM_URLS_REQUEST_KEY]) !== null && _c !== void 0 ? _c : null;
    });
    var uploading = loadingUploadUrls || transferring || loadingPreSummary || loadingFromUrls;
    var hasPreSummary = Boolean(responsePreSummary);
    var fetchDetail = function () {
        if (!id)
            return;
        dispatch(customRequestApis({
            requestKey: DETAIL_REQUEST_KEY,
            method: "GET",
            path: "/asg/Api/V1/Collections/".concat(id),
        }));
    };
    useEffect(fetchDetail, [id]);
    var isProcessingPayments = (detail === null || detail === void 0 ? void 0 : detail.status) === COLLECT_PROCESSING_STATUS;
    var isCompleted = (detail === null || detail === void 0 ? void 0 : detail.status) === COLLECT_COMPLETED_STATUS;
    useEffect(function () {
        var clearPoll = function () {
            if (pollTimeoutRef.current !== null) {
                clearTimeout(pollTimeoutRef.current);
                pollTimeoutRef.current = null;
            }
        };
        clearPoll();
        if (!isProcessingPayments) {
            pollStartedAtRef.current = null;
            return clearPoll;
        }
        if (pollStartedAtRef.current === null) {
            pollStartedAtRef.current = Date.now();
        }
        if (Date.now() - pollStartedAtRef.current >= COLLECT_POLL_MAX_DURATION_MS) {
            return clearPoll;
        }
        pollTimeoutRef.current = setTimeout(fetchDetail, COLLECT_POLL_INTERVAL_MS);
        return clearPoll;
    }, [isProcessingPayments, detail, errorDetail]);
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(DETAIL_REQUEST_KEY));
            dispatch(clearCustomRequest(UPLOAD_URLS_REQUEST_KEY));
            dispatch(clearCustomRequest(PRE_SUMMARY_REQUEST_KEY));
            dispatch(clearCustomRequest(FROM_URLS_REQUEST_KEY));
        };
    }, []);
    useEffect(function () {
        if (errorDetail) {
            setToast({
                show: true,
                type: "error",
                message: COLLECT_GENERIC_ERROR_MESSAGE,
            });
        }
    }, [errorDetail]);
    var setItemStatus = function (name, status) {
        setUploadStatuses(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = status, _a)));
        });
    };
    var uploadItems = newFiles.map(function (file) {
        var _a;
        return ({
            name: file.name,
            status: (_a = uploadStatuses[file.name]) !== null && _a !== void 0 ? _a : CardFileUploadStatus.Pending,
        });
    });
    var transferFiles = function (signed) { return __awaiter(void 0, void 0, void 0, function () {
        var uploaded, expired, _loop_1, _i, signed_1, target;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setTransferring(true);
                    uploaded = [];
                    expired = false;
                    _loop_1 = function (target) {
                        var file, error_1;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    file = filesRef.current.find(function (item) { return item.name === target.name; });
                                    if (!file)
                                        return [2 /*return*/, "continue"];
                                    setItemStatus(target.name, CardFileUploadStatus.Uploading);
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, putToSignedUrl(target.url, file, file.type || COLLECT_DEFAULT_CONTENT_TYPE)];
                                case 2:
                                    _b.sent();
                                    setItemStatus(target.name, CardFileUploadStatus.Uploaded);
                                    uploaded.push(target);
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_1 = _b.sent();
                                    if ((error_1 === null || error_1 === void 0 ? void 0 : error_1.status) === COLLECT_EXPIRED_LINK_STATUS) {
                                        expired = true;
                                    }
                                    setItemStatus(target.name, CardFileUploadStatus.Error);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    };
                    _i = 0, signed_1 = signed;
                    _a.label = 1;
                case 1:
                    if (!(_i < signed_1.length)) return [3 /*break*/, 4];
                    target = signed_1[_i];
                    return [5 /*yield**/, _loop_1(target)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4:
                    setTransferring(false);
                    if (uploaded.length !== signed.length) {
                        setToast({
                            show: true,
                            type: "error",
                            message: expired
                                ? COLLECT_UPLOAD_LINK_EXPIRED_MESSAGE
                                : COLLECT_UPLOAD_FAILED_MESSAGE,
                        });
                        return [2 /*return*/];
                    }
                    uploadedFilesRef.current = uploaded;
                    dispatch(customRequestApis({
                        requestKey: PRE_SUMMARY_REQUEST_KEY,
                        method: "POST",
                        path: "/asg/Api/V1/Collections/Pre-Summary/".concat(id),
                        body: {
                            files: uploaded.map(function (target) { return ({
                                key: target.key,
                                name: target.name,
                            }); }),
                        },
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
    var onClickProcess = function () {
        dispatch(customRequestApis({
            requestKey: FROM_URLS_REQUEST_KEY,
            method: "POST",
            path: "/asg/Api/V1/Collections/Inputs/".concat(id, "/from-urls"),
            body: {
                files: uploadedFilesRef.current.map(function (target) { return ({
                    key: target.key,
                    name: target.name,
                }); }),
            },
        }));
    };
    var onOpenReviewModal = function () { return setReviewModalOpen(true); };
    var onCloseReviewModal = function () { return setReviewModalOpen(false); };
    var onOpenConfirmModal = function () {
        setReviewModalOpen(false);
        setConfirmModalOpen(true);
    };
    var onCloseConfirmModal = function () { return setConfirmModalOpen(false); };
    var resetPreSummaryState = function () {
        if (!hasPreSummary)
            return;
        uploadedFilesRef.current = [];
        setReviewModalOpen(false);
        setConfirmModalOpen(false);
        dispatch(clearCustomRequest(PRE_SUMMARY_REQUEST_KEY));
    };
    useEffect(function () {
        var _a;
        var signed = (_a = responseUploadUrls === null || responseUploadUrls === void 0 ? void 0 : responseUploadUrls.files) !== null && _a !== void 0 ? _a : [];
        if (signed.length === 0)
            return;
        dispatch(clearCustomRequest(UPLOAD_URLS_REQUEST_KEY));
        void transferFiles(signed);
    }, [responseUploadUrls]);
    useEffect(function () {
        if (!responsePreSummary)
            return;
        setReviewModalOpen(true);
    }, [responsePreSummary]);
    useEffect(function () {
        if (!responseFromUrls)
            return;
        setToast({
            show: true,
            type: "success",
            message: COLLECT_UPLOAD_SUCCESS_MESSAGE,
        });
        setNewFiles([]);
        setUploadStatuses({});
        setReviewModalOpen(false);
        setConfirmModalOpen(false);
        dispatch(clearCustomRequest(PRE_SUMMARY_REQUEST_KEY));
        dispatch(clearCustomRequest(FROM_URLS_REQUEST_KEY));
        fetchDetail();
    }, [responseFromUrls]);
    useEffect(function () {
        if (errorUploadUrls || errorPreSummary || errorFromUrls) {
            setTransferring(false);
            setToast({
                show: true,
                type: "error",
                message: COLLECT_GENERIC_ERROR_MESSAGE,
            });
        }
    }, [errorUploadUrls, errorPreSummary, errorFromUrls]);
    var closeToast = function () {
        setToast({ show: false, message: "", type: "success" });
    };
    var rejectFiles = function (message) {
        setToast({ show: true, type: "error", message: message });
    };
    var onFilesAdded = function (files) {
        var withValidExtension = files.filter(function (file) {
            return hasAllowedExtension(file.name);
        });
        if (withValidExtension.length < files.length) {
            rejectFiles(COLLECT_EXTENSION_MESSAGE);
        }
        var withValidSize = withValidExtension.filter(function (file) {
            return isWithinSizeLimit(file.size);
        });
        if (withValidSize.length < withValidExtension.length) {
            rejectFiles(COLLECT_FILE_SIZE_MESSAGE);
        }
        if (withValidSize.length === 0)
            return;
        var room = maxFiles - newFiles.length;
        if (room <= 0) {
            rejectFiles(buildCollectMaxFilesMessage(maxFiles));
            return;
        }
        var accepted = withValidSize.slice(0, room);
        if (accepted.length < withValidSize.length) {
            rejectFiles(buildCollectMaxFilesMessage(maxFiles));
        }
        resetPreSummaryState();
        setNewFiles(function (prev) { return __spreadArray(__spreadArray([], prev, true), accepted, true); });
    };
    var onRemoveFile = function (index) {
        resetPreSummaryState();
        setNewFiles(function (prev) { return prev.filter(function (_, i) { return i !== index; }); });
    };
    var onDownloadFile = function (file) {
        var link = document.createElement("a");
        link.href = file.url;
        link.download = file.fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    var onClickBack = function () { return navigate("/admin/cobranza"); };
    var onClickUpload = function () {
        if (!id || newFiles.length === 0) {
            setToast({
                show: true,
                type: "error",
                message: COLLECT_NO_FILES_SELECTED_MESSAGE,
            });
            return;
        }
        setUploadStatuses({});
        dispatch(customRequestApis({
            requestKey: UPLOAD_URLS_REQUEST_KEY,
            method: "POST",
            path: "/asg/Api/V1/Collections/Inputs/".concat(id, "/upload-urls"),
            body: {
                files: newFiles.map(function (file) { return ({
                    name: file.name,
                    contentType: file.type || COLLECT_DEFAULT_CONTENT_TYPE,
                    sizeBytes: file.size,
                }); }),
            },
        }));
    };
    var bucket = detail
        ? getCollectionStatusToneBucket(detail.status)
        : "IN_PROGRESS";
    var rulePillCandidates = detail
        ? [
            ((_e = detail.parameters) === null || _e === void 0 ? void 0 : _e.cancelMonth)
                ? {
                    label: "Cancela ".concat(detail.parameters.cancelMonth, " meses"),
                    tone: "warning",
                }
                : null,
            ((_f = detail.parameters) === null || _f === void 0 ? void 0 : _f.maxInvoicesPerPolicy)
                ? {
                    label: "M\u00E1x. ".concat(detail.parameters.maxInvoicesPerPolicy, " facturas"),
                    tone: "muted",
                }
                : null,
            ((_g = detail.parameters) === null || _g === void 0 ? void 0 : _g.filePerProduct)
                ? { label: "Separar archivos", tone: "muted" }
                : null,
        ]
        : [];
    var rulePills = rulePillCandidates.filter(function (pill) { return pill !== null; });
    var period = detail
        ? formatCollectionPeriod((_j = (_h = detail.parameters) === null || _h === void 0 ? void 0 : _h.actualMonth) !== null && _j !== void 0 ? _j : "", (_l = (_k = detail.parameters) === null || _k === void 0 ? void 0 : _k.billingType) !== null && _l !== void 0 ? _l : "")
        : "";
    var resultSummary = (_m = detail === null || detail === void 0 ? void 0 : detail.completionSummary) !== null && _m !== void 0 ? _m : {};
    var formatCurrencyRD = function (raw) {
        var amount = Number(raw !== null && raw !== void 0 ? raw : 0);
        return "RD$ ".concat(amount.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }));
    };
    var resultKpis = RESULT_KPI_DEFS.map(function (def) {
        var _a;
        return ({
            id: def.id,
            label: def.label,
            tone: def.tone,
            value: def.id === "totalPaidAmount"
                ? formatCurrencyRD(resultSummary[def.id])
                : String((_a = resultSummary[def.id]) !== null && _a !== void 0 ? _a : 0),
        });
    });
    var preSummarySuccess = hasPreSummary;
    var preSummaryValidation = responsePreSummary;
    var reviewItems = REVIEW_ITEM_DEFS.map(function (def) {
        var _a;
        return ({
            id: def.id,
            label: def.label,
            tone: "neg",
            value: String((_a = resultSummary[def.id]) !== null && _a !== void 0 ? _a : 0),
        });
    });
    var bottomBarButtons = [
        {
            id: "back",
            label: COLLECT_BACK_BUTTON_LABEL,
            variant: "default",
            onClick: onClickBack,
            disabled: uploading,
        },
        {
            id: "upload",
            label: hasPreSummary
                ? COLLECT_PROCESS_BUTTON_LABEL
                : COLLECT_UPLOAD_BUTTON_LABEL,
            color: "brand",
            onClick: hasPreSummary ? onOpenConfirmModal : onClickUpload,
            loading: uploading,
            disabled: hasPreSummary
                ? uploading || isCompleted
                : newFiles.length === 0 || uploading || isCompleted,
        },
    ];
    return {
        hasDetail: Boolean(detail),
        loadingDetail: loadingDetail,
        uploading: uploading,
        toast: toast,
        closeToast: closeToast,
        title: isCompleted ? COLLECT_PAGE_TITLE_COMPLETED : COLLECT_PAGE_TITLE,
        uploadDisabled: isCompleted || uploading,
        statusLabel: detail ? getCollectionStatusLabel(detail.status) : "",
        statusTone: (_o = STATUS_BUCKET_TO_TONE[bucket]) !== null && _o !== void 0 ? _o : "info",
        period: period,
        userName: (_q = (_p = detail === null || detail === void 0 ? void 0 : detail.parameters) === null || _p === void 0 ? void 0 : _p.userName) !== null && _q !== void 0 ? _q : "",
        createdAt: detail ? formattedDate(detail.createdAt) : "",
        collectionOption: COLLECT_DEFAULT_COLLECTION_OPTION,
        batchNumber: COLLECT_NO_VALUE_LABEL,
        periodPillLabel: detail
            ? formatCollectionMonthYear((_s = (_r = detail.parameters) === null || _r === void 0 ? void 0 : _r.actualMonth) !== null && _s !== void 0 ? _s : "")
            : "",
        productLabels: detail
            ? ((_u = (_t = detail.parameters) === null || _t === void 0 ? void 0 : _t.projects) !== null && _u !== void 0 ? _u : [])
                .filter(function (project) { var _a, _b; return ((_b = (_a = detail.parameters) === null || _a === void 0 ? void 0 : _a.projectsId) !== null && _b !== void 0 ? _b : []).includes(project.id); })
                .map(function (project) { return project.description; })
            : [],
        productCount: productCount,
        maxPeriods: ((_v = detail === null || detail === void 0 ? void 0 : detail.parameters) === null || _v === void 0 ? void 0 : _v.maxRebillingMonths)
            ? String(detail.parameters.maxRebillingMonths)
            : COLLECT_NO_VALUE_LABEL,
        rulePills: rulePills,
        existingFiles: detail
            ? ((_w = detail.batchFiles) !== null && _w !== void 0 ? _w : []).map(function (file) { return ({
                fileName: file.url.split("/").pop() || file.url,
                url: file.url,
            }); })
            : [],
        uploadItems: uploadItems,
        maxFiles: maxFiles,
        onFilesAdded: onFilesAdded,
        onRemoveFile: onRemoveFile,
        onDownloadFile: onDownloadFile,
        resultKpis: resultKpis,
        reviewItems: reviewItems,
        bottomBarButtons: bottomBarButtons,
        hasPreSummary: hasPreSummary,
        reviewModalOpen: reviewModalOpen,
        onOpenReviewModal: onOpenReviewModal,
        onCloseReviewModal: onCloseReviewModal,
        confirmModalOpen: confirmModalOpen,
        onOpenConfirmModal: onOpenConfirmModal,
        onCloseConfirmModal: onCloseConfirmModal,
        onConfirmProcess: onClickProcess,
        preSummarySuccess: preSummarySuccess,
        preSummaryValidation: preSummaryValidation,
    };
};
